import type { Nullable } from "@opensea/utils"
import { create } from "zustand"
import { persist } from "zustand/middleware"
import { mutative } from "zustand-mutative"

type WhatsNewModalStoreState = {
  forceState: Nullable<"open" | "closed">
  lastSeen: Nullable<Date>
  overrideLastSeen: Nullable<Date>
}

type WhatsNewModalStoreActions = {
  setForceState: (forceState: WhatsNewModalStoreState["forceState"]) => void
  setLastSeen: (lastSeen: WhatsNewModalStoreState["lastSeen"]) => void
  setOverrideLastSeen: (
    lastSeen: WhatsNewModalStoreState["overrideLastSeen"],
  ) => void
  close: () => void
}

type WhatsNewModalStore = WhatsNewModalStoreState & WhatsNewModalStoreActions

export const WhatsNewModalStore = create<WhatsNewModalStore>()(
  persist(
    mutative((set, _get) => ({
      forceState: null,
      lastSeen: null,
      overrideLastSeen: null,
      setForceState: forceState => {
        set(state => {
          state.forceState = forceState
        })
      },
      setLastSeen: lastSeen => {
        set(state => {
          state.lastSeen = lastSeen
        })
      },
      setOverrideLastSeen: lastSeen => {
        set(state => {
          state.overrideLastSeen = lastSeen
        })
      },
      close: () => {
        set(state => {
          state.lastSeen = new Date()
          state.forceState = "closed"
          state.overrideLastSeen = null
        })
      },
    })),
    {
      name: "whats-new-modal",
      partialize: state => ({
        lastSeen: state.lastSeen,
      }),
    },
  ),
)
